import { MOBILE_EXAMPLES } from 'constants/libphonenumberPhoneExamples';

export const DEFAULT_MASK = '... ... ... ... ..';

const maskCache = {};

// Example: "7440 000031" -> ".... ...... .." or "xxx xxx xxxx" -> "... ... ...."
export const toMask = (templateString) => {
    return (
        (templateString || '')
            .replace(/\u00A0/g, ' ')
            .replace(/\d/g, '.')
            .replace(/x/g, '.')
            .trim() || DEFAULT_MASK
    );
};

export const getMobileIntlMaskForCountry = async (iso2) => {
    const region = (iso2 || '').toUpperCase();
    if (!region) return DEFAULT_MASK;
    if (maskCache[region]) {
        return maskCache[region];
    }
    try {
        const lib = window && window.libphonenumber ? window.libphonenumber : null;
        if (!lib) return DEFAULT_MASK;

        const exampleNumber = lib.getExampleNumber(region, MOBILE_EXAMPLES);
        if (exampleNumber) {
            const internationalFormat = exampleNumber.formatInternational();
            const countryCallingCode = exampleNumber.countryCallingCode;
            const nationalPart = internationalFormat.replace(new RegExp(`^\\+${countryCallingCode}\\s*`), '');
            const mask = toMask(nationalPart);
            if (mask && mask.includes('.')) {
                maskCache[region] = mask;
                return mask;
            }
        }
        return DEFAULT_MASK;
    } catch (error) {
        return DEFAULT_MASK;
    }
};

export const buildMasksObject = (iso2OrList) => {
    const list = Array.isArray(iso2OrList) ? iso2OrList : [iso2OrList];
    return list.reduce((acc, code) => {
        if (code) acc[code] = getMobileIntlMaskForCountry(code);
        return acc;
    }, {});
};
